import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { adsConversion, ADS_LABELS, trackSpaPageView } from "@/lib/tracking";

// Globaler Klick-Listener (Event Delegation): erfasst JEDEN tel:-Link und
// JEDEN WhatsApp-Link (wa.me / api.whatsapp.com / whatsapp://), auch wenn
// Buttons spaeter dazukommen. Der Link oeffnet sich danach normal weiter.
// Conversions feuern nur mit Marketing-Einwilligung und konfiguriertem Label.
export default function TrackingListener() {
  const location = useLocation();
  const firstPath = useRef(location.pathname);

  // SPA: page_view bei jedem Routenwechsel (erster Aufruf kommt aus dem <head>)
  useEffect(() => {
    if (location.pathname === firstPath.current) return; // initial schon gesendet
    trackSpaPageView(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const link = e.target.closest && e.target.closest("a[href]");
      if (!link) return;
      const href = link.getAttribute("href") || "";
      if (href.startsWith("tel:")) {
        adsConversion(ADS_LABELS.phone);
      } else if (/wa\.me|api\.whatsapp\.com|^whatsapp:/i.test(href)) {
        adsConversion(ADS_LABELS.whatsapp);
      }
    };
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, []);

  return null;
}
